import { Navigation } from "../swiper/swiperConfig";

const configRsySlider = {
  allowTouchMove: false,
  direction: "horizontal",
  modules: [Navigation],
  speed: 800,
  slidesPerView: "auto",
  observer: true,
  observeParents: true,
  spaceBetween: 0,
  breakpoints: {
    800: {
      slidesOffsetBefore: 33,
      slidesOffsetAfter: 33,
    },
  },
};

export default configRsySlider;
